import {TextStyle as NativeTextStyle, ViewStyle} from 'react-native';

import {TextStyle} from '../components/Typography';

export * from './colors';

// TODO: Replace with typography
export const profileTitleStyle: NativeTextStyle = {
  fontSize: 26,
  fontFamily: 'Roboto-Bold',
  fontWeight: '400',
  textAlign: 'center',
  letterSpacing: 0.38,
  lineHeight: 25,
};

export const profileSliderSwitchTitleStyle: NativeTextStyle = {
  fontSize: 14,
  fontFamily: 'Roboto-Regular',
  letterSpacing: 0.35,
  fontWeight: '400',
};

export const profileDurationTitleStyle = {
  fontSize: 12,
  fontFamily: 'Roboto-Regular',
};

export const navTextButtonTitleStyle: NativeTextStyle = {
  fontFamily: 'BigShouldersDisplay-Medium',
  fontWeight: '400',
  fontSize: 16,
  letterSpacing: 0.6,
};

export const fillStyle: Pick<
  ViewStyle,
  'display' | 'flex' | 'width' | 'height'
> = {
  display: 'flex',
  flex: 1,
  width: '100%',
  height: '100%',
};

export const centerStyle: Pick<
  ViewStyle,
  'display' | 'alignItems' | 'justifyContent'
> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const centeredColumnStyle: Pick<
  ViewStyle,
  'display' | 'flexDirection' | 'alignItems' | 'justifyContent'
> = {
  ...centerStyle,
  flexDirection: 'column',
};

export const centeredRowStyle: Pick<
  ViewStyle,
  'display' | 'flexDirection' | 'alignItems' | 'justifyContent'
> = {
  ...centerStyle,
  flexDirection: 'row',
};

export const centerText: Partial<TextStyle> = {
  textAlign: 'center',
};

export const underlineText: Partial<TextStyle> = {
  textDecorationLine: 'underline',
};

export const bold: Partial<TextStyle> = {
  fontWeight: '700',
};

export const lowercase: Partial<TextStyle> = {
  textTransform: 'lowercase',
};
